const ipmArrowRight = `
<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h20v20H0z"/>
        <path class="icon-color" d="M5.776 1.773a1.535 1.535 0 0 1 2.15 0l6.598 6.474c.752.739.793 1.929.115 2.716l-.115.123-6.597 6.474a1.535 1.535 0 0 1-2.15 0 1.479 1.479 0 0 1-.02-2.09l5.912-5.803-5.893-5.784a1.479 1.479 0 0 1-.097-2.005l.097-.105z" fill="#038AB7" fill-rule="nonzero"/>
    </g>
</svg>
`

export default ipmArrowRight
